import { ADULT_MINIMUM_AGE } from '@/Age';

import { getCurrentPlainDate, getPlainDateOrNullFrom } from './temporalUtils';

/**
 * Returns the age calculated in whole years for given date string,
 * or null if the date or input is invalid.
 */
export const getAgeInYearsFromBirthdayIsoDateString = (birthdayIsoString: string): number => {
  const birthdayPlainDate = getPlainDateOrNullFrom(birthdayIsoString);

  if (!birthdayPlainDate) {
    throw new Error(`Cannot calculate age from invalid ISO date, ${birthdayIsoString}`);
  }

  const age = getCurrentPlainDate().since(birthdayPlainDate, {
    largestUnit: 'year',
  }).years;
  return age;
};

/**
 * Returns the age calculated in whole years for given date string,
 * or null if the date or input is invalid.
 */
export const getAgeInMonthsFromBirthdayIsoDateString = (birthdayIsoString: string): number => {
  const birthdayPlainDate = getPlainDateOrNullFrom(birthdayIsoString);
  if (!birthdayPlainDate) {
    throw new Error(`Cannot calculate age from invalid ISO date, ${birthdayIsoString}`);
  }
  const age = getCurrentPlainDate().since(birthdayPlainDate, {
    largestUnit: 'month',
  }).months;
  return age;
};

/**
 * Returns true if the birthdate has reached the given age.
 */
export const isBirthdayIsoDateStringAtLeastNYearsOld = (
  birthday: string,
  minimumAgeInYears: number
): boolean => {
  return getAgeInYearsFromBirthdayIsoDateString(birthday) >= minimumAgeInYears;
};

/**
 * Returns true if the birthdate has reached adult age
 */
export function isBirthdayIsoDateStringAdultAge(birthday: string): boolean {
  return getAgeInYearsFromBirthdayIsoDateString(birthday) >= ADULT_MINIMUM_AGE;
}
